import { useCallback, useEffect } from 'react';
import type { ListViewIssuesReturn as QueryData } from '../../../services/get-list-view-issues/types';
import { useIssueFields } from '../../get-issue-fields';
import { useRowCreateStore } from '../../row-create';
import { useHierarchyConfig } from '../hierarchy-config';
import { useHierarchyStore } from '../hierarchy-store';

export const useSetHierarchyData = () => {
	const [, { setHierarchyData, refreshHierarchy }] = useHierarchyStore();
	const [rowCreateState, { setRowCreatePosition }] = useRowCreateStore();
	const { hierarchyLevelsWithCache } = useIssueFields();
	const { showFlatList } = useHierarchyConfig();

	useEffect(() => {
		refreshHierarchy(rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache);
	}, [rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache, refreshHierarchy]);

	const setHierarchyDataWithDependencies = useCallback(
		(queryData: QueryData) =>
			setHierarchyData(
				queryData,
				rowCreateState,
				setRowCreatePosition,
				hierarchyLevelsWithCache,
				showFlatList,
			),
		[
			setHierarchyData,
			rowCreateState,
			setRowCreatePosition,
			hierarchyLevelsWithCache,
			showFlatList,
		],
	);

	return { setHierarchyData: setHierarchyDataWithDependencies };
};
